import { render, staticRenderFns } from "./PersonPhoto.vue?vue&type=template&id=2c4f1a6f&scoped=true&"
import script from "./PersonPhoto.vue?vue&type=script&lang=js&"
export * from "./PersonPhoto.vue?vue&type=script&lang=js&"
import style0 from "./PersonPhoto.vue?vue&type=style&index=0&id=2c4f1a6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f1a6f",
  null
  
)

export default component.exports